import router from '@/router'
import { make, dispatch } from 'vuex-pathify'
import qs from 'qs'

const state = {
    show_drawer: true,
    drawer_sections: {
        tareas_expanded: true,
        alianzas_expanded: true,
        aula_expanded: true,
        etiquetas_expanded: true 
    },
 
    pagination: {
        sortBy: "id",
        descending: true,
        page: 1,
        rowsPerPage: 10,
        rowsNumber: 10,
    },

    search: null,

    visible_columns: [
        'id', 'nombre', 'email', 'celular', 'rol', 'created_at', 'estatus'
    ],
}

const mutations = {
    ...make.mutations(state),

    /**
     * Reset state.
     * @param {Object} current 
     */
    reset(current) {
        Object.assign(current, state)
    },
}

const actions = {
    /**
     * Clear search and reload data.
     * @param {Object} context
     * @returns {void}
     */
    clear({ commit }) {
        commit('search', null)
    },

    async search({ commit }, search) {
        commit('search', search)
        router.push({ name: 'dashboard' }, () => {})
    },
}

export default {
    namespaced: true,
    state,
    mutations,
    actions,
}